import React, { useState } from 'react';
import { FaPlay } from 'react-icons/fa';

function getEmbedUrl(url) {
  if (!url) return null;
  // YouTube
  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1`;
  // Vimeo
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
  // URL no reconocida — rechazar en vez de inyectar directamente al iframe.
  // Evita que un editor del blog persista payloads tipo javascript:/data: en ctaLink/url.
  return null;
}

export default function BlogVideoBlock({ data }) {
  const { url, thumbnail, caption, autoplay } = data;
  const [playing, setPlaying] = useState(false);
  const embedUrl = getEmbedUrl(url);

  // Video subido (MP4 en R2) o cualquier URL directa que no sea YouTube/Vimeo:
  // se reproduce con un <video> nativo. Antes esto no funcionaba (getEmbedUrl
  // devolvía null y nunca se pintaba nada reproducible).
  const isDirect = !!url && !embedUrl;

  return (
    <div className="blog-video-block">
      <div className="blog-video-wrapper">
        {isDirect ? (
          <video
            src={url}
            className="blog-video-iframe"
            controls
            playsInline
            preload="metadata"
            poster={thumbnail || undefined}
            autoPlay={!!autoplay}
            muted={!!autoplay}
          />
        ) : playing && embedUrl ? (
          <iframe
            src={embedUrl}
            className="blog-video-iframe"
            allow="autoplay; fullscreen"
            allowFullScreen
            title="Video"
          />
        ) : (
          <div className="blog-video-thumbnail" onClick={() => setPlaying(true)}>
            {thumbnail && <img src={thumbnail} alt={caption || 'Video'} />}
            <button className="blog-video-play" aria-label="Play video">
              <FaPlay />
            </button>
          </div>
        )}
      </div>
      {caption && <p className="blog-video-caption">{caption}</p>}
    </div>
  );
}
